import React from "react";
import { RiArrowGoBackFill } from "react-icons/ri";
import { AiAppCreateForm } from "@components";
import { Card, Row, Col } from "antd";

const AiAppCreate = ({ history }) => {
  return (
    <>
      <Card style={{ borderRadius: "0", height: "100vh", overflowY: "auto" }}>
        <Row>
          <Col span={24}>
            <Row>
              <RiArrowGoBackFill
                style={{ fontSize: "2em", cursor: "pointer" }}
                onClick={() => history.goBack()}
              />
              <h3
                className="hp-mb-16"
                style={{
                  marginLeft: "1em",
                  fontSize: "1.75em",
                }}
              >
                Create a AI App
              </h3>
            </Row>
            {/* Space */}
            <Row style={{ marginTop: "1em" }} />
            {/* AiApp Create Form */}
            <AiAppCreateForm />
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default AiAppCreate;
